<template>
  <div>
    <v-card elevation="0" class="mr-4">
      <v-card-text>
        <p class="display-1 text--primary">
          <span v-if="workspace.State === 'AVAILABLE'">Workspace ready to use -</span>
          <span v-else>Workspace soon ready -</span>
          getting started
        </p>
        <p class="text--primary">
          Download your preferred Workspace client from the links below.
          <br />The Workspace is ready for use when the status below is
          Available.
          <br />Enter the following Registration Code in the
          workspace client:
          <strong>{{workSpaceCode}}</strong>.
          <br />Then in
          the username field enter your username:
          <strong>{{ username }}</strong>.
          <br />Enter the password you created previously on this
          page, and lastly get the MFA code from your MFA device.
        </p>
      </v-card-text>
      <v-card class="d-flex justify-space-between mb-10" elevation="0">
        <v-card elevation="0" class="ml-5 d-flex flex-column justify-center">
          <v-btn
            href="https://d2td7dqidlhjx7.cloudfront.net/prod/global/windows/Amazon+WorkSpaces.msi"
            target="_blank"
            width="20rem"
          >Download Windows client</v-btn>
          <br />
          <v-btn
            href="https://d2td7dqidlhjx7.cloudfront.net/prod/global/osx/WorkSpaces.pkg"
            target="_blank"
            width="20rem"
          >Download Mac OS X client</v-btn>
          <br />
          <v-btn
            href="https://clients.amazonworkspaces.com/"
            target="_blank"
            width="20rem"
            color="grey lighten-3"
          >More options</v-btn>
        </v-card>
        <workspace-status />
      </v-card>
      <v-card-text v-if="workspace.State !== 'AVAILABLE'">
        <p class="text--secondary">
          It can take up to 40 minutes from the Workspace request is
          approved to the workspace is available.
          <br />The status window will automatically update from
          "PENDING" to "AVAILABLE" when the workspace ready.
          <br />
          <br />If you're logged out of this page due to being
          idle you can log back in with the new password that you
          created in the previous steps.
        </p>
      </v-card-text>
    </v-card>
    <v-card elevation="0" class="mr-4">
      <v-card-title class="display-1">Rebuilding workspace</v-card-title>
      <v-card-text>
        <p class="text--primary">
          If you experience serious issues with your workspace after rebooting (which you do in the menubar of the workspace application and
          not inside the windows workspace window) as unresponsive applications or windows itself, you can rebuild your workspace.
          Rebuilding a workspace implies that:
        </p>

        <ul class="mt-5">
          <li>it restores the WorkSpace's root volume from the bundle, and recreate the user volume from the latest snapshot. Removes applications installed by users that are not part of the bundle. Rebuilding may remove user data stored within the past 12 hours. A rebuilt WorkSpace may incur increased charges if launched from a custom bundle with modified storage.</li>
          <li>The latest snapshot is taken within the last 12 hours</li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">Rebuild</v-btn>
          </template>

          <v-card>
            <v-card-title class="headline grey lighten-2">Confirm rebuild</v-card-title>

            <v-card-text
              class="mt-5"
            >You will loose work if you haven't commited changes during the last 12 hours. Rebuilding takes approximately 40 minutes.</v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
              <v-btn @click="rebuild">Rebuild</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Authentication from "../auth";
import WorkspaceStatus from "../components/WorkspaceCard";

export default {
  components: {
    WorkspaceStatus,
  },

  data() {
    return {
      dialog: false,
      workspace: {},
      isHEWorkSpace: null
    };
  },
  async created() {
    if (this.$store.state.workSpace.State) {
      this.workspace = this.$store.state.workSpace;
    } else {
      this.workspace = await this.$store.dispatch("getWorkSpace");
    }

    this.isHEWorkSpace = !!(await this.$store.dispatch('isHEEnv'))
    await this.$store.dispatch("userDetails");
  },

  computed: {
    username() {
      return Authentication.getUser().sAMAccountName;
    },
    name() {
      return ` ${this.$store.state.userDetails.userDetails.cn} ` || "";
    },
    isLoaded() {
      return this.$store.state.userDetails.userDetails;
    },
    workSpaceCode() {
      return this.isHEWorkSpace ? 'wsdub+RYR8HU' : 'wsdub+PB2DTX'
    }
  },
  methods: {
    async isHEWorkspace() {
      return (await this.$store.dispatch('isHEEnv'))
    },
    async rebuild() {
      this.dialog = false;

      const env = await this.$store.dispatch('isHEEnv') ? 'PROD' : 'DEV';

      await Authentication.fetch("api/ws/rebuild", "POST", {
        environment: env,
      });
    },
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
